import { APIMethod, fetchData } from "@client";

export async function getAllLabelsQuery(
  group, // from utils/labelGroups
) {
  const res = await fetchData(`/v1/labels?limit=100&sort=oldest&group=${group}`, APIMethod.GET);
  return res.results || [];
}